
import "../Services.css";
import DeskImage from "../../Assets/Images/Tax-Return.jpg";
import TaxFAQ from "./TaxFAQ.js";

const App = () => {
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>Tax Returns: Maximize Savings, Minimize Stress!</h1>
            <p className="hero-subtitle">Accurate filings, proactive planning, and year-round tax support.</p>
          </div>
          <div className="hero-media">
            <img src={DeskImage} alt="Tax Returns" className="desk-image" />
          </div>
        </div>
      </div>
      <TaxFAQ />
    </section>
  );
};

export default App;
